import { useMutation, UseMutationOptions, useQueryClient } from '@tanstack/react-query';
import { ReadPage } from '@tinct/core-api-models';
import { ApiError, tinctApi } from '../../api';

export interface UnpublishPageParams {
  pageId: string;
}

export const unpublishPage = async (params: UnpublishPageParams): Promise<ReadPage> => {
  return await tinctApi.pages.unpublishPage(params.pageId);
};

export const useUnpublishPage = (
  options?: Omit<
    UseMutationOptions<ReadPage, ApiError, UnpublishPageParams>,
    'mutationFn'
  >,
) => {
  const { onSuccess, ...restOptions } = options || {};
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: unpublishPage,
    onSuccess: (...args) => {
      queryClient.invalidateQueries({ queryKey: ['pages'] });
      queryClient.invalidateQueries({ queryKey: ['campaign'] });
      queryClient.invalidateQueries({ queryKey: ['campaigns'] });
      onSuccess?.(...args);
    },
    ...restOptions,
  });
};
